import { RefreshCw } from "lucide-react";
import { useT } from "@ec2/i18n/react";
import { useSwUpdate } from "../lib/swUpdate";

/**
 * "Update available — reload" banner (SW prompt mode). Non-blocking, sits
 * above the bottom nav; reload only on tap, never automatic.
 */
export function UpdateBanner() {
  const t = useT();
  const { needRefresh, apply } = useSwUpdate();
  if (!needRefresh || !apply) return null;
  return (
    <div
      role="status"
      data-testid="ec-update-banner"
      className="fixed inset-x-0 bottom-[calc(88px+env(safe-area-inset-bottom))] z-50 mx-auto flex w-fit max-w-[calc(100%-2rem)] items-center gap-3 rounded-(--radius-card) border border-border bg-surface-raised px-4 py-3 shadow-xl"
    >
      <span className="text-[13px] font-medium text-fg">{t("ec2.update.available")}</span>
      <button
        type="button"
        onClick={apply}
        data-testid="ec-update-reload"
        className="flex items-center gap-1.5 rounded-(--radius-chip) bg-primary px-3 py-1.5 text-[13px] font-semibold text-primary-fg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      >
        <RefreshCw size={14} aria-hidden />
        {t("ec2.update.reload")}
      </button>
    </div>
  );
}
